// extracted by mini-css-extract-plugin
module.exports = {"link":"ForgotPasswordLink-module__link___2h352"};